import { APP_INITIALIZER, ApplicationConfig, importProvidersFrom, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideHttpClient, withInterceptorsFromDi, HTTP_INTERCEPTORS } from '@angular/common/http';

import { routes } from './app.routes';
import { MsalInterceptor, MsalService } from '@azure/msal-angular';
import { azureAdMsalModule } from './auth.config';
import { ChatClaimsChallengeInterceptor } from './chat-claims-challenge.interceptor';

function initMsal(msalService: MsalService) {
  return () => msalService.initialize();
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    provideAnimationsAsync(),
    // withInterceptorsFromDi() enables class-based HTTP_INTERCEPTORS (MsalInterceptor)
    provideHttpClient(withInterceptorsFromDi()),

    // Sets up MSAL_INSTANCE, MSAL_GUARD_CONFIG, MSAL_INTERCEPTOR_CONFIG, and MsalService
    importProvidersFrom(azureAdMsalModule),
    // MsalModule.forRoot does NOT register the interceptor — must add it explicitly
    { provide: HTTP_INTERCEPTORS, useClass: MsalInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ChatClaimsChallengeInterceptor, multi: true },

    {
      provide: APP_INITIALIZER,
      useFactory: initMsal,
      deps: [MsalService],
      multi: true,
    },
  ],
};
